/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getCleanBuildingName
 */

/**
 * returns a building name if it does not look like an address, undefined otherwise
 *
 * @param {string} name building name
 * @returns String, building name if it is not an address, or undefined
 */

export const getCleanBuildingName = (name: string) => {
  const bName = name.trim()

  if (/apartments/i.test(bName)) {
    return bName
  }
  return /^\s*\d+\s/i.test(bName) ? '' : bName
}
